/**
 * cartBasicUiCoreDiscountRulesRepository
 */
angular.module('app-ui-profile').service(
    'profileRepository',
    [
        'pipeRatApiRepositoryPromiseService',
        function (
            pipeRatApiRepositoryPromiseService
        ) {
            return pipeRatApiRepositoryPromiseService.getNewRepository(
                '/api/resource/user-profile',
                'relivConferenceUserProfileService'
            );
        },
    ]
);
